export enum UserRoleEnum {
  MEMBER = 'MEMBER',
  ADMIN = 'ADMIN',
  SYSTEM_ADMIN = 'SYSTEM_ADMIN'
}

export interface UserInfo {
  id: string;
  email: string;
  firstName: string;
  lastName: string | null;
  isVerified: boolean;
  isOnboarded: boolean;
  organizationId?: string;
  role?: UserRoleEnum;
  phone?: string | null;
  profileImage?: string | null;
  authMethod?: string | null;
  organizationName?: string;
  createdAt: string;
  status: boolean;
}

export interface ResetPasswordRequest {
  email: string;
  token: string;
  newPassword: string;
  confirmPassword: string;
}

export interface ResetPasswordResponse {
  none: string;
}

export interface ForgotPasswordRequest {
  email: string;
}

export interface UserBalanceResponse {
  amount: number;
}

export interface DecreaseBalanceRequest {
  amount: number;
  simulationId?: string;
  description?: string;
}

export interface SignupRequest {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  role: UserRoleEnum;
  organizationId?: string;
}

export interface SignUpResponse {
  isVerified: boolean;
  oneTimePasswordId: string;
  userId: string;
}

export interface SignInRequest {
  email: string;
  password: string;
}

export interface SignInResponse {
  accessToken: string;
  intercomToken: string;
  organizationId: string;
  user: {
    id: string;
    isVerified: boolean;
    isOnboarded: boolean;
    firstName: string;
    lastName: string;
    role: UserRoleEnum;
  };
}

export interface EditProfileRequest {
  firstName: string;
  lastName: string;
  phone: string;
  organizationName?: string;
}

export interface ChangePasswordRequest {
  userId: string;
  newPassword: string;
}

export interface ChangePasswordResponse {
  none: string;
}
